//Styles
import {CSSProperties} from 'react';
import * as S from './GITickBox.styles';

interface GITickBoxProps {
  label?: string;
  isSelected?: boolean;
  id?: string;
  onBoxClick?: (e: any) => void;
  width?: string;
  height?: string;
  wrapperStyles?: CSSProperties;
  labelStyles?: CSSProperties;
  arrowWidth?: string;
}

const GITickBox = ({
  label = '',
  isSelected = false,
  id = '',
  onBoxClick = (e: any) => {},
  width = '20px',
  height = '20px',
  arrowWidth = '6px',
  wrapperStyles = {},
  labelStyles = {},
}: GITickBoxProps) => {
  const generatedId = id || 'gitickbox-' + label.replace(/\s+/g, '-');

  const onToggle = (e: any) => {
    e?.stopPropagation();
    onBoxClick(e);
  };

  return (
    <S.FilterCheckboxItem
      key={generatedId}
      onClick={e => e?.stopPropagation()}
      $wrapperStyles={wrapperStyles}
    >
      <S.FilterInput
        type="checkbox"
        id={generatedId}
        checked={isSelected}
        onClick={onToggle}
        $width={width}
        $height={height}
        $arrowWidth={arrowWidth}
        readOnly
      />
      <S.FilterLabel
        htmlFor={generatedId}
        dangerouslySetInnerHTML={{__html: label}}
        $labelStyles={labelStyles}
      />
    </S.FilterCheckboxItem>
  );
};

export default GITickBox;
